import styled from '@emotion/styled';
import {
  Icon,
  Typography,
  useGlimmerTheme,
} from '@innovamat/glimmer-components';

export type Props = React.HTMLAttributes<HTMLDivElement> & {
  text: string | JSX.Element;
};

const Container = styled.div`
  width: 100%;
  background-color: ${({ theme }) =>
    theme.tokens.color.specific['smart-guides']['part1-background'].value};
  padding: 16px;
  gap: 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;

  @media print {
    padding: 12px;
  }
`;

export function SummarySectionAdditionalTraining({
  text,
}: Props): JSX.Element | null {
  const { tokens } = useGlimmerTheme();
  return (
    <Container role="alert">
      <Icon
        icon={'TrainingSessionIcon'}
        size="L"
        iconColor={
          tokens.color.specific['smart-guides']['communication-element'].value
        }
      />
      <Typography.Body2>{text}</Typography.Body2>
    </Container>
  );
}
